import { useSelectedInvoice } from "@/components/invoices/invoiceStates";
import InvoiceTable from "@/components/invoices/invoiceTable";
import { Button } from "@/components/ui/button";

import { Plus } from "lucide-react";

import { useNavigate } from "react-router-dom";

export function RegisterInvoice() {
  // const { tempSelectedMonth, setTempSelectedMonth } = useTempSelectedMonth();
  // const { selectedMonth, setSelectedMonth } = useSelectedMonth();
  // const { tempSelectYear, setTempSelectYear } = useTempSelectedYear();
  // const { selectedYear, setSelectedYear } = useSelectedYear();
  // const { setSelectedBuildingName, selectedBuildingName } =
  //   useSelectedBuildingName();
  // const { tempSelectedBuildingName, setTempSelectedBuildingName } =
  //   useTempSelectedBuildingName();
  const navigate = useNavigate();

  // const { setPageSize } = usePageState();
  // const { setCurrentPage } = useSetPage();
  // const { invoices, currentPage } = fetchInvoices();

  // const totalPages = invoices?.totalPages || 1;
  // const totalItems = invoices?.totalInvoices || 0;

  const { setSelectedInvoice } = useSelectedInvoice();

  // function handleFilterSubmit(event: React.FormEvent) {
  //   event.preventDefault();
  //   setSelectedMonth(tempSelectedMonth); // Set selectedMonth only when 'Apply Filter' is pressed
  //   setSelectedYear(tempSelectYear); // Set selectedYear only when 'Apply Filter' is pressed
  //   setSelectedBuildingName(tempSelectedBuildingName);
  // }

  // const months = Array.from({ length: 12 }, (_, index) => ({
  //   value: (index + 1).toString(),
  //   label: new Intl.DateTimeFormat("en", { month: "long" }).format(
  //     new Date(0, index),
  //   ),
  // }));

  // const currentYear = new Date().getFullYear();
  // const years = Array.from({ length: currentYear - 1999 }, (_, index) => ({
  //   value: (currentYear - index).toString(),
  //   label: (currentYear - index).toString(),
  // }));

  return (
    <div>
      <div className="flex h-14 items-center rounded-b-2xl bg-[#16A34A] bg-opacity-40 px-10">
        <h3 className="p-5 font-Hemmers text-3xl text-black">Invoices</h3>
      </div>
      <div className="py-2">
        <div className="flex items-center justify-between p-4">
          <Button
            onClick={() => {
              setSelectedInvoice(null);
              navigate("/invoices/create");
            }}
            className="gap-x-2 border border-black bg-[#FAFAFA] text-lg text-black hover:bg-gray-200"
          >
            <Plus className="size-4" /> Create New
          </Button>
          <div className="ml-auto flex items-center gap-4">
            <Button className="border border-black bg-[#FAFAFA] text-lg text-black hover:bg-gray-200">
              Add Filter
            </Button>
          </div>
        </div>
      </div>
      <div className="mx-4 rounded-lg border border-black bg-[#FAFAFA] p-4">
        <InvoiceTable />
      </div>
    </div>
  );
}
